export default __webpack_public_path__ + "static/media/Rectangulo-5.d16e0b9f.webp";